export { default } from './MedalFirst'
